module.exports = __webpack_public_path__ + "static/media/icon_extension_doc.317f1e92.svg";